import { configureStore } from '@reduxjs/toolkit'
import persistedReducer from '../reducers'
import { persistStore } from 'redux-persist';

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST"], // Ignore redux-persist actions
        },
      }),
  });
export const persistor = persistStore(store);
